import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { getApiUrl } from 'shared-kernel/helpers';
import { baseReducers, getBaseActions } from "./base";

const name = 'role';

const slice = createSlice({
    name,
    initialState,
    reducers: {
        ...baseReducers,
        getForAccessReceived: (state, payload) => ({
            ...state,
            isFetching: false,
            items: payload.data
        }),
        submitAccessReceived: state => ({
            ...state,
            isFetching: false
        })
    }
});

const { _set, requested, failed, itemReceived, itemsReceived, deleteReceived, submitReceived, getForAccessReceived, submitAccessReceived } = slice.actions;

export default slice.reducer;

const { baseSet, baseGet, baseSubmit, baseDelete } = getBaseActions(requested.type, failed.type);

export const set = payload => baseSet(_set.type, payload);

export const get = id => baseGet(name, itemReceived.type, { id });

export const submit = data => baseSubmit(name, submitReceived.type, data);

export const remove = ids => baseDelete(name, deleteReceived.type, ids);

export const getAll = () => ({
    types: [requested.type, itemsReceived.type, failed.type],
    url: getApiUrl(name, 'getall')
});

export const getAccess = roleId => ({
    types: [requested.type, getForAccessReceived.type, failed.type],
    url: getApiUrl(name, 'get4access'),
    payload: { roleId }
});

export const submitAccess = data => ({
    types: [requested.type, submitAccessReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'submitaccess'),
    payload: data
});